module.exports = __webpack_public_path__ + "img/mail.639c9b80.svg";